// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-badge__badge.error:empty{display:none}.v-avatar.v-list-item__avatar.rounded.unseen{overflow:visible}.v-avatar.v-list-item__avatar.rounded.unseen:before{background-color:#d00;border-radius:50%;content:\"\";height:6px;left:-2px;position:absolute;top:-2px;width:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
